import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import {
  DeviceAddRequest,
  DeviceAddResponse,
  DeviceDeleteRequest,
  DeviceResponse,
  ImportDeviceAddRequest,
  UnaddedDevicesResponse as NotAddedDevicesResponse,
} from '@entities/device';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  constructor(private api: ApiService) {}

  /**
   * QualcommとMacnica Tracks(RDS)それぞれにのみ存在するデバイスを取得する
   */
  compare(): Observable<NotAddedDevicesResponse> {
    const url = '/devices-compare-list';
    return this.api.get<NotAddedDevicesResponse>(url);
  }

  /**
   * デバイスを追加する
   * @param request 登録内容
   */
  add(request: DeviceAddRequest): Observable<void> {
    const url = '/devices';
    return this.api.post<void>(url, request);
  }

  /**
   * デバイスを一括登録する
   * @param request 登録内容
   */
  bulkAdd(request: ImportDeviceAddRequest[]): Observable<DeviceAddResponse> {
    const url = '/devices/_import';
    return this.api.post<DeviceAddResponse>(url, request);
  }

  /**
   * デバイス一覧を取得する
   * @returns デバイス一覧
   */
  findAll(tenantId: string, contractStartedAt: string|undefined, contractExpiredAt: string|undefined): Observable<DeviceResponse[]> {
    let url = '/devices?nogroup=false'
    if(tenantId){
      url = url + `&tenant_id_for_search=${tenantId}`
    }
    if(contractStartedAt){
      url = url + `&contract_date_from=${contractStartedAt}`
    }
    if(contractExpiredAt){
      url = url + `&contract_date_to=${contractExpiredAt}`
    }
    return this.api.get<DeviceResponse[]>(url);
  }

  /**
   * デバイスを更新する
   * @param request 更新内容
   */
  update(serialNo: string, request: DeviceAddRequest): Observable<void> {
    const url = `/devices/${serialNo}`;
    return this.api.put<void>(url, request);
  }

  /**
   * デバイスを削除する
   * @param request 削除内容
   */
  delete(request: DeviceDeleteRequest[]): Observable<void> {
    const url = '/devices/_delete';
    return this.api.post<void>(url, request);
  }
}
